import {
    DATA_DICTIONARY_BASKET_ADD,
    DATA_DICTIONARY_BASKET_ADD_MANY,
    DATA_DICTIONARY_BASKET_REMOVE,
    DATA_DICTIONARY_BASKET_CLEAR,
    DATA_DICTIONARY_BASKET_STORAGE_KEY
} from './types';

// Hydrate from localStorage so a pinned basket survives reloads. Anything
// malformed (old shape, hand-edited, quota weirdness) degrades to empty.
const loadPersistedItems = () => {
    try {
        const raw = window.localStorage.getItem(DATA_DICTIONARY_BASKET_STORAGE_KEY);
        const items = raw ? JSON.parse(raw) : [];
        return Array.isArray(items) ? items.filter((i) => i && i.columnKey) : [];
    } catch (e) {
        return [];
    }
};

const initialState = {
    items: loadPersistedItems()
};

const dataDictionaryBasketReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case DATA_DICTIONARY_BASKET_ADD: {
            if (state.items.some((i) => i.columnKey === payload.columnKey)) return state;
            return { ...state, items: [...state.items, payload] };
        }
        case DATA_DICTIONARY_BASKET_ADD_MANY: {
            const existing = new Set(state.items.map((i) => i.columnKey));
            const fresh = (payload || []).filter((i) => i.columnKey && !existing.has(i.columnKey));
            if (fresh.length === 0) return state;
            return { ...state, items: [...state.items, ...fresh] };
        }
        case DATA_DICTIONARY_BASKET_REMOVE:
            return { ...state, items: state.items.filter((i) => i.columnKey !== payload) };
        case DATA_DICTIONARY_BASKET_CLEAR:
            return { ...state, items: [] };
        default:
            return state;
    }
};

export default dataDictionaryBasketReducer;
